import React, { useEffect, useState } from 'react';
import { updateGDPR } from './data/data-service';
import { getCookie } from '../../DAL/storage-provider';
import { sendGAEvent } from '../../domain/marketing/gtm-provider';
import {
    checkIfGPCBannerAlreadyShown,
    GDRP_COOKIE_NAME,
    getGdprCookieFromServer,
    getGdprCountry, isGpcEnabled,
    setGDPRCookie, setGPCBannerAlreadyShown
} from './domain/gdpr-provider';
import { getHiddenDataString, getIsAuthenticated } from '../../domain/hidden-data-provider';
import GDPRWidgetLawyer from './gdpr-widget/gdpr-widget-lawyer';
import GDPRWidget from './gdpr-widget/gdpr-widget';

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-1833
 */
const GDPR = () => {
    const gdprCookieFromServer = getGdprCookieFromServer();
    const cookie = getCookie(GDRP_COOKIE_NAME);
    const isUserLoggedIn = getIsAuthenticated();

    const [isShowWidget, setIsShowWidget] = useState(false);
    const [isLawyerWidget, setIsLawyerWidget] = useState(false);
    const [showGpcText, setShowGpcText] = useState(false);

    const country = getGdprCountry();

    const showWidget = () => {
        setIsShowWidget(true);
        sendGAEvent('Consent Widget','Widget Displayed');
    };

    useEffect(() => {

        (async () => {
            if(country === 'y' &&
                isGpcEnabled() &&
                !checkIfGPCBannerAlreadyShown()) {
                setShowGpcText(true);
                setIsShowWidget(true);
                setIsLawyerWidget(true);
                setGPCBannerAlreadyShown();
                return;
            }

            if(cookie) {

                // Don't show widget if there is a client-side cookie.
                setIsShowWidget(false);

                if(isUserLoggedIn) {
                    if(gdprCookieFromServer) {

                        // We have cookie in client side and cookie from server,
                        // and the user is logged in.
                        // Update client side cookie with server cookie.
                        setGDPRCookie(gdprCookieFromServer);
                    }
                    else{
                        // We have a cookie in client side, but don't have the
                        // server side cookie, and the user is logged in.
                        // Update database with the cookie.
                        await updateGDPR();
                    }
                }
            }
            else{
                // NO COOKIE -----------------------
                if(isUserLoggedIn) {
                    if(gdprCookieFromServer) {

                        // We don't have cookie in client side and have cookie from server,
                        // and the user is logged in.
                        // Update client side cookie with server cookie.
                        setGDPRCookie(gdprCookieFromServer);
                    }
                    else{
                        // https://wavesaudio.atlassian.net/browse/DSWEB-4435
                        const gdprCountryResult = getHiddenDataString('gdpr-country');
                        setIsLawyerWidget(gdprCountryResult === 'y');

                        // There is no both client-side and server-side cookies.
                        // We need to show the widget in this case.

                        // 15.4.2026 hide widget if gdpr-country == 'no'
                        // https://wavesaudio.atlassian.net/browse/DSWEB-5151
                        // if(gdprCountryResult !== 'n') {
                            showWidget();
                        // }
                    }
                }
                else{
                    // https://wavesaudio.atlassian.net/browse/DSWEB-4435
                    const gdprCountryResult = getHiddenDataString('gdpr-country');
                    setIsLawyerWidget(gdprCountryResult === 'y');

                    // The user is not logged in, and we don't have client side cookie
                    // ---> show the widget.

                    // 15.4.2026 hide widget if gdpr-country == 'no'
                    // https://wavesaudio.atlassian.net/browse/DSWEB-5151
                    // if(gdprCountryResult !== 'n') {
                        showWidget();
                    // }
                }
            }
        })();

    },[
        cookie,
        isUserLoggedIn,
        gdprCookieFromServer,
        country,
    ])

    return(
        <div>
            {
                isShowWidget && (
                    <>
                        { !isLawyerWidget && <GDPRWidget /> }
                        { isLawyerWidget && <GDPRWidgetLawyer isGpc={ showGpcText } /> }
                    </>
                )
            }
        </div>
    )
}

export default GDPR;